import "./configPage.css";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, omit } from "lodash";
import { Button, Input, Typography, Modal } from "antd";
import { ReactComponent as ConfirmIcon } from "../../assets/waiting-for-approval.svg";
import {
  clearConfigError,
  fixObligationIds,
  generateObligationIds,
  restoreToFactorySettings,
  updateAppConfig
} from "../../store/forms/actions";

const ConfigPage = () => {
  const dispatchito = useDispatch();
  const config = useSelector(state => state.forms.appConfig);
  const configError = useSelector(state => state.forms.appConfigError);
  const initialText = JSON.stringify(
    omit(config, ["_id", "createdAt", "updatedAt", "__v", "configType"]),
    undefined,
    4
  );
  const [open, setOpen] = useState(false);
  const [openFix, setOpenFix] = useState(false);
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(initialText);
  const [hintJSON, setHintJSON] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState();

  const checkJSONStructure = str => {
    try {
      JSON.parse(str);
      setHintJSON("");
    } catch (e) {
      setHintJSON(e.name + ": " + e.message);
      return false;
    }
    return true;
  };

  const prettify = value => {
    try {
      console.debug("value", value);
      if (checkJSONStructure(value)) {
        setHintJSON("");
        const ugly = JSON.parse(value);
        const pretty = JSON.stringify(ugly, undefined, 4);
        return pretty;
      }
    } catch (err) {
      console.debug(err);
      setHintJSON(err);
    }
    return value;
  };

  useEffect(() => {
    if (prettify(text) !== prettify(initialText)) {
      setMsg("Unsaved changes");
    } else setMsg("");
  }, [text, initialText]);

  useEffect(() => {
    if (!isEmpty(config)) {
      setText(initialText);
    }
  }, [config]);

  return (
    <>
      <div id="config-page">
        <div id="config-control">
          <Button onClick={() => setEdit(true)}>Edit</Button>
          <Button onClick={() => setText(prettify(text))}>Prettify</Button>
          <Button
            disabled={!edit}
            onClick={() => {
              setEdit(false);
              setText(initialText);
              dispatchito(clearConfigError());
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={!edit}
            onClick={() => {
              if (checkJSONStructure(text)) {
                dispatchito(
                  updateAppConfig({
                    payload: JSON.parse(text),
                    callback: res => {
                      if (res) {
                        setEdit(false);
                        setText(initialText);
                      }
                    }
                  })
                );
              }
            }}
          >
            Save
          </Button>
          <Button
            onClick={async () => {
              if (checkJSONStructure(text)) {
                setEdit(false);
                setOpen(true);
              }
            }}
          >
            Restore
          </Button>
          <Typography.Text type="warning">{msg}</Typography.Text>
          <Typography.Text type="danger">{configError}</Typography.Text>
          <Typography.Text type="danger">{hintJSON}</Typography.Text>
          <Button
            onClick={async () => {
              dispatchito(generateObligationIds());
            }}
          >
            Generate Obligation IDs
          </Button>
          <Button
            onClick={async () => {
              setOpenFix(true);
            }}
          >
            Fix Main Obligation IDs
          </Button>
        </div>
        <Input.TextArea
          id="config-json-textarea"
          // cols={100}
          // rows={20}
          status={error ? "error" : ""}
          disabled={!edit}
          value={text}
          onChange={e => {
            setText(e.target.value);
          }}
        />
      </div>
      <Modal
        title="Warning!"
        open={open}
        centered
        width={450}
        onOk={() => {
          setOpen(false);
          dispatchito(
            restoreToFactorySettings({
              callback: res => {
                if (res) {
                  setEdit(false);
                  setText(initialText);
                }
              }
            })
          );
        }}
        onCancel={() => setOpen(false)}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          You are about to restore the configuration to factory settings and all
          changes will be lost.
        </p>
        <p>Are you sure you wish to continue?</p>
      </Modal>
      <Modal
        title="Warning!"
        open={openFix}
        centered
        width={450}
        onOk={() => {
          setOpenFix(false);
          dispatchito(fixObligationIds("main"));
        }}
        onCancel={() => setOpenFix(false)}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          You are about to re-generate Main Obligations' ids. This action will
          overwrite existing codes and may create mismatches in audit texts if
          they have already been generated.
        </p>
        <p>Are you sure you wish to continue?</p>
      </Modal>
    </>
  );
};

export default ConfigPage;
